import {setupFetchCsrf} from './common/csrf';
import {initInvoicePreview} from './common/invoice-preview';
import {installCbarMessageDialogGlobals} from './common/cbar-message-dialog';
import {setupI18n} from './i18n';
import {documentReady} from "./document-ready";
import {setupLogoutHandler} from "./handle-logout";
import {notifySilentLoginParent, setupOAuthPopup} from "./oauth-popup";
import {action, controller, importRouteJs} from "./routes";

installCbarMessageDialogGlobals();

if (controller === 'admin' || controller === 'report') {
    initInvoicePreview();
    import('./admin/init');
}
import {handleHeaderSidenav, setupOrganisationDropdownListeners} from "./header";
import {setupAppShell} from "./shell";
import {setupThemeModeSwitcher} from "./theme-mode";
import {defaultEmptyCbarSelectValues, setupCbarSelectHydration, setupCbarSelectJqueryBridge, setupCbarSelectSubmitSync} from "./cbar-select-bridge";
import {setupCbarAutocompleteBridge} from "./common/cbar-autocomplete-bridge";
import {setupCbarDateInputBridge} from "./cbar-date-input-bridge";
import {setupCbarCheckboxBridge} from "./cbar-checkbox-bridge";
import {setupCbarSelectSizing} from "./cbar-select-sizing";
import {setupMobileDatatableColumnVisibility} from "./cbar-datatable";
import {setupFilterCardOverflowWhenReady} from "./common/filter-card-overflow";
import {setupDatatableScrollHintsWhenReady} from "./common/datatable-scroll-hint";
import {markPendingServerSideDatatablesLoading} from "./common/server-pagination";
import './controllers/helper/init';

setupFetchCsrf();

// Import the js for this controller/action, if it exists.
importRouteJs(controller, action)
    .catch(() => 'No file found, that\'s ok.');

import './datatables/registry';

documentReady().then(async e => {
    markPendingServerSideDatatablesLoading();
    await setupI18n();

    // Popup/iframe OAuth handoff (success via #redirect_url, failure via #auth_failed)
    notifySilentLoginParent();
    setupOAuthPopup();
    setupLogoutHandler();
    await setupOrganisationDropdownListeners();
    setupAppShell();
    await setupThemeModeSwitcher();
    setupCbarSelectJqueryBridge();
    setupCbarSelectSubmitSync();
    defaultEmptyCbarSelectValues();
    void setupCbarSelectHydration();
    setupCbarAutocompleteBridge();
    setupCbarDateInputBridge();
    setupCbarCheckboxBridge();
    setupCbarSelectSizing();
    setupMobileDatatableColumnVisibility();
    void setupFilterCardOverflowWhenReady();
    setupDatatableScrollHintsWhenReady();

    handleHeaderSidenav();

});
